<template>
  <div class="box">
    <table class="table is-fullwidth" v-show="!loading && docs.length > 0">
      <thead>
        <tr>
          <th>Request Date</th>
          <th>Employee ID</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Email</th>
          <th>From</th>
          <th>To</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="travel in docs" :key="travel._id">
          <td>{{ travel.createdAt | date }}<p>{{ travel.createdAt | time }}</p></td>
          <td>{{ travel.employeeId }}</td>
          <td>{{ travel.name }}</td>
          <td>{{ travel.mobile }}</td>
          <td>{{ travel.email }}</td>
          <td>{{ travel.startDate | date }}</td>
          <td>{{ travel.endDate | date }}</td>
          <td class="actions">
            <router-link :to="`/request/travel/view/${travel._id}`">View</router-link>
            <router-link :to="`/request/travel/edit/${travel._id}`">Edit</router-link>
            <router-link :to="`/request/travel/delete/${travel._id}`" class="has-text-danger">Delete</router-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="has-text-centered">
      <button class="button is-loading is-large" v-show="loading"></button>
      <p
        class="has-text-grey"
        v-show="!loading && docs.length === 0"
      >No records matching these criteria</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["travel/docs"];
    },
    loading() {
      let component = this;
      return component.$store.getters["travel/loading"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("travel/index");
  }
};
</script>
<style lang="scss" scoped>
.actions {
  a {
    padding-right: 16px;
  }
}
button.is-loading {
  border: none;
}
</style>
